import React from 'react';
import { View, Text } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { ITaskAssignee } from '@/types/admin/tasks';
import { DesktopOverflowText } from '@/components/common/admin/desktop/DesktopOverflowText';

export const TaskAssignee = ({ assignees }: { assignees?: ITaskAssignee[] }) => {
  const list = assignees || [];
  const count = list.length;
  const first = list[0];
  const initials = first ? `${first.firstName?.[0] || ''}${first.lastName?.[0] || ''}` : '';
  const fullNames = list
    .map(a => `${a.firstName || ''} ${a.lastName || ''}`.trim())
    .filter(Boolean);

  const getAssigneeText = () => {
    if (count === 0) return 'Unassigned';
    if (count === 1) return `${first?.firstName || ''} ${first?.lastName || ''}`.trim() || (first?.email || '');
    return `${count} assignees`;
  };

  return (
    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8, minWidth: 0 }}>
      <View style={{ width: 24, height: 24, borderRadius: 12, alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(255,255,255,0.06)', borderWidth: 1, borderColor: ADMIN_COLORS.BORDER }}>
        {count === 0 && (
          <Text style={{ color: ADMIN_COLORS.TEXT_SECONDARY, fontSize: 10, fontWeight: '600' }}>–</Text>
        )}
        {count === 1 && (
          <Text style={{ color: ADMIN_COLORS.TEXT_SECONDARY, fontSize: 10, fontWeight: '600' }}>{initials}</Text>
        )}
        {count > 1 && (
          <Text style={{ color: ADMIN_COLORS.TEXT_SECONDARY, fontSize: 10, fontWeight: '600' }}>+{count}</Text>
        )}
      </View>
      {count <= 1 ? (
        <Text numberOfLines={1} style={{ color: ADMIN_COLORS.TEXT_SECONDARY, fontSize: 12, flexShrink: 1 }}>
          {getAssigneeText()}
        </Text>
      ) : (
        <View style={{ flex: 1, minWidth: 0 }}>
          <DesktopOverflowText
            text={`${list[0].firstName || ''} ${(list[0].lastName || '')}`.trim() + (count > 1 ? ` +${count - 1}` : '')}
            title={'Assigned to:'}
            tooltipText={fullNames.join('\n')}
            numberOfLines={1}
            align={'start'}
          />
        </View>
      )}
    </View>
  );
};


